import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  // Quote snowflake IDs (incl. locationId + nested location.id) before JSON.parse.
  const text = raw.replace(
    /("(?:journeyId|accommodationId|ownerMemberId|creatorMemberId|memberId|createdByMemberId|locationId|id)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey accommodations — independent of Day/Activity schedule. */
export const journeyAccommodationApi = {
  list: (journeyId) => travelClient.get(
    travelEndpoints.journeyAccommodations(journeyId),
    snowflakeJson,
  ),
  get: (journeyId, accommodationId) => travelClient.get(
    travelEndpoints.journeyAccommodation(journeyId, accommodationId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyAccommodations(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, accommodationId, body) => travelClient.patch(
    travelEndpoints.journeyAccommodation(journeyId, accommodationId),
    body,
    snowflakeJson,
  ),
  remove: (journeyId, accommodationId, { confirm = true } = {}) => travelClient.delete(
    travelEndpoints.journeyAccommodation(journeyId, accommodationId),
    { params: { confirm }, ...snowflakeJson },
  ),
};
